export default __webpack_public_path__ + "assets/5d16aadf0cb35adb6bed3c06f3fe437e.png";